module.exports = "../../app/cells/components/common_questions/show.erb";